import React from 'react'
import CourseCategoryPage from "../components/CourseCategoryPage";
import { getTrips } from "../services/api";
function Trips() {
  return (
    <div>
      <CourseCategoryPage
      queryKey="trips"
      fetchFn={getTrips}
      popupStorageKey="tripspage_popup_dismissed_this_tab"
      errorMessage="Failed to load trips."
    />
    </div>
  )
}

export default Trips
